// in src/posts.js
import React, { useEffect, useState } from 'react';
import { Filter, DeleteButton, DateField, RichTextField, SimpleShowLayout, Show, ShowButton, SimpleList, BooleanInput, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextFieldFrom from '@mui/material/TextField';
import { useMediaQuery } from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getAuthApp } from '../services/security/authApp';
import Constants from '../shared/constants';
import Popup from 'reactjs-popup';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

//import DateTimePicker from 'material-ui/DateTimePicker';

//Utils
import { Box, Button, Dialog, DialogActions, DialogContent, CardActions, DialogContentText, DialogTitle } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Autocomplete from '@mui/material/Autocomplete';
import Alert from '@mui/material/Alert';

//material-ui table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { MenuItem } from '@mui/material';


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const FiltrarCupones = (props) => (
    <Filter {...props}>
        <TextInput source="porcentaje_descuento" alwaysOn />
    </Filter>
);

const handleExportExcelCupones = () => {
    try {
        const authToken = getAuthApp();

        const headers = new Headers();
        headers.append('Authorization', `${authToken}`);

        const downloadURL = Constants.general.serverURL + "/api/cupones/csvexport/xmls";

        fetch(downloadURL, {
            method: 'GET',
            headers: headers
        })
            .then(response => {
                if (response.ok) {
                    response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = 'Cupones.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    });
                } else {
                    throw new Error('Error al descargar el archivo');
                }
            })
            .catch(error => {
                console.error(error);
            });
    } catch (error) {
        console.error(error);
    }
};

const ActionsListCupones_Reportes = () => {
    return (
        <CardActions style={cardActionStyle}>
            <FlatButton primary
                label="Exportar Excel"
                onClick={handleExportExcelCupones}
            />
        </CardActions>
    );
};

export const ListaCupones = (props) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Cupones De Descuento" filters={<FiltrarCupones />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.nombre_cupon}
                    secondaryText={record => `${record.fecha_hora_inicio} - ${record.fecha_hora_final}`}
                    tertiaryText={record => `Descuento: ${record.porcentaje_descuento}%`}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="nombre_cupon" label="Nombre Cup�n" />
                    <TextField source="porcentaje_descuento" label="% Descuento" />
                    <TextField source="fecha_hora_inicio" label="Fecha y Hora Inicio" />
                    <TextField source="fecha_hora_final" label="Fecha y Hora Fin" />
                    <TextField source="numero_cupones_redimir" label="Cupones a Redimir" />
                    <TextField source="numero_cupones_redimidos" label="Cupones Redimidos" />
                    <TextField source="numero_cupones_disponibles" label="Cupones Disponibles" />
                    <ShowButton label="Producto" />
                    <TextField source="estado_cupon" label="Estado" />
                    <EditButton />
                </Datagrid>
            )}
        </List>
    );
};

const TituloCupones = ({ record }) => {
    return <span>Cupones de Descuento{record ? `"${record.title}"` : ''}</span>;
};


export const EditarCupones = (props) => {
    //estado del cupon despues de consultado
    const [estadoCupon, setEstadoCupon] = useState('');
    const [estadoNuevoCupon, setEstadoNuevoCupon] = useState('');
    const [estadoConsultaCupon, setEstadoConsultaCupon] = useState('');
    const [selectedNoFraccionesMinimas, setSelectedNoFraccionesMinimas] = useState('');
    const [selectedNoFraccionesMaximas, setSelectedNoFraccionesMaximas] = useState('');
    //estados para el op up
    const [showMessage, setShowMessage] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [showConfirmationActulizar, setShowConfirmationActulizar] = useState(false);
    const [showConfirmationActulizacion, setShowConfirmationActulizacion] = useState(false);

    const [mensageServicio, setMensageServicio] = useState("");
    const [fechaFinal, setfechaFinal] = useState("");
    const [cuponesDisponibles, setcuponesDisponibles] = useState("");
    const fechaActual = new Date();

    const [noFraccionesMinimas, setNoFraccionesMinimas] = useState('');
    const [errorNoFraccionesMinimas, setErrorNoFraccionesMinimas] = useState('');

    const [noFraccionesMaximas, setNoFraccionesMaximas] = useState('');
    const [errorNoFraccionesMaximas, setErrorNoFraccionesMaximas] = useState('');


    //variable que retorna el id editar
    let id = props.match.params['id'];
    let idEsatadoCupon = props.match.params['estado_cupon'];
    let values = [{}];
    values = {
        "id": id
    };

    const handleConfirmationActulizacionNo = () => {
        setShowConfirmationActulizacion(false);
    };

    const handleConfirmationNo = () => {
        setShowConfirmation(false);
    };

    const handleConfirmationYes = () => {
        setShowConfirmation(false);
        // let fechaFinalConvertido= new Date(fechaFinal,("YYYY-mm-dd"));
        let valorMinimoCupones = 0;
        let estadoCuponValidacion = "ACTIVO";
        let fechaInicialConvertido = new Date(fechaFinal);
        let fechaInicialHorasConvertidas = new Date(fechaInicialConvertido.setHours(fechaInicialConvertido.getHours() + 5));
        const minFracciones = selectedNoFraccionesMinimas ? parseInt(selectedNoFraccionesMinimas) : noFraccionesMinimas;
        const maxFracciones = selectedNoFraccionesMaximas ? parseInt(selectedNoFraccionesMaximas) : noFraccionesMaximas;
        if (estadoNuevoCupon !== estadoCupon || minFracciones !== noFraccionesMinimas || maxFracciones !== noFraccionesMaximas) {
            actualizarEstadoCupon();
        } else {
            setMensageServicio("No se realizó ninguna modificación en el cupón.");
            setShowMessage(true);
        }if (estadoNuevoCupon === estadoCupon || estadoNuevoCupon === "") {
            setMensageServicio("No se realiza actualización, ya que el valor actual es igual al modificar");
            setShowMessage(true)
        } else if (estadoNuevoCupon === estadoCuponValidacion) {
            if (fechaInicialHorasConvertidas.getTime() >= fechaActual.getTime() && cuponesDisponibles > valorMinimoCupones) {
                const editarEstadoCupon = async () => {
                    try {
                        const authToken = getAuthApp();
                        const headers = new Headers();
                        headers.append('Content-Type', 'application/json');
                        headers.append('Authorization', `${authToken}`);
                        const url = `${Constants.general.serverURL}/api/cupones/post-edit-state`;
                        const body = {
                            coupon: values,
                            state: estadoNuevoCupon
                        };
                        console.warn('BODY', JSON.stringify(body));
                        const response = await fetch(url, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify({ confisys: body }, null, 2)
                        });
                        if (response.ok) {
                            const responseData = await response.json();
                            const responseMessage = responseData.req;
                            setMensageServicio(responseMessage.message);
                            setShowMessage(true)
                        } else {
                            setMensageServicio('Error al actulizar estado cupón');
                            setShowMessage(true)
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                editarEstadoCupon();
            } else {
                setMensageServicio("No es posible activar el Cupón, valide la información vigente");
                setShowConfirmationActulizacion(true)
            }
        }
        else {
            const editarEstadoCupon = async () => {
                try {
                    const authToken = getAuthApp();
                    const headers = new Headers();
                    headers.append('Content-Type', 'application/json');
                    headers.append('Authorization', `${authToken}`);
                    const url = `${Constants.general.serverURL}/api/cupones/post-edit-state`;
                    const body = {
                        coupon: values,
                        state: estadoNuevoCupon
                    };
                    console.warn('BODY', JSON.stringify(body));
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({ confisys: body }, null, 2)
                    });
                    if (response.ok) {
                        const responseData = await response.json();
                        const responseMessage = responseData.req;
                        setMensageServicio(responseMessage.message);
                        setShowMessage(true)
                    } else {
                        setMensageServicio('Error al actulizar estado cupón');
                        setShowMessage(true)
                    }
                } catch (error) {
                    console.error(error);
                }
            }
            editarEstadoCupon();
        }
        /**/
    }
    //validacion de que se traiga el id del editar 
    if (!id) {
        alert("Se realizó un error en el sistema recargué la página de Nuevo");
    } else {
        //cargar el estado de id selecionado
        const consultarEstadoCupon = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = `${Constants.general.serverURL}/api/cupones/post-consult-state`;
                const body = {
                    coupon: values
                };
                console.warn('BODY', JSON.stringify(body));
                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ confisys: body }, null, 2)
                });
                if (response.ok) {
                    const responseData = await response.json();
                    const responseMessage = responseData.req;
                    setfechaFinal(responseMessage.body.fecha_hora_final);
                    setcuponesDisponibles(responseMessage.body.numero_cupones_disponibles);
                    if (responseMessage.body.estado_cupon === "ACTIVO") {
                        setEstadoCupon('ACTIVO');
                        setEstadoConsultaCupon('ACTIVO');
                    } else {
                        setEstadoCupon('INACTIVO');
                        setEstadoConsultaCupon('ACTIVO');
                    }
                    setNoFraccionesMinimas(responseMessage.body.numeroFraccionesMinimas);
                    setNoFraccionesMaximas(responseMessage.body.numeroFraccionesMaximas);


                } else {
                    throw new Error('Error al consultar estado cupón');
                }
            } catch (error) {
                console.error(error);
            }
        }
        consultarEstadoCupon();
    }
    //cargar los estados selecionados 
    const handleEstadoCuponChange = (event, value) => {
        setEstadoNuevoCupon(value);
    };
    const handleNumeroFraccionesMinimas = (event) => {
        const value = event.target.value;
        setSelectedNoFraccionesMinimas(value);
    };
    const handleNumeroFraccionesMaximas = (event) => {
        const value = event.target.value;
        setSelectedNoFraccionesMaximas(value);
    };

    const handleOnchengeEdit = (e) => {
        e.preventDefault(); // Previene el comportamiento por defecto del formulario si lo hay

        if (parseInt(selectedNoFraccionesMinimas) > parseInt(selectedNoFraccionesMaximas)) {
            setErrorNoFraccionesMinimas({
                error: true,
                message: "El número de fracciones mínimas no puede ser mayor que el número de fracciones máximas."
            });
        } else {
            setErrorNoFraccionesMinimas({
                error: false,
                message: ''
            });
            setShowConfirmation(true); 
        }
    };
    return (
        <Edit  {...props} title="Editar Estado Cupón">
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px', paddingTop: '20px' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    }}
                    component="form"
                    onSubmit={handleOnchengeEdit}
                >
                    <Autocomplete
                        defaultValue={estadoCupon ? estadoCupon : estadoConsultaCupon}
                        onChange={handleEstadoCuponChange}
                        options={estados}
                        sx={{ width: 300 }}
                        id="controllable-states-demo"
                        renderInput={(params) => (
                            <TextFieldFrom
                                {...params}
                                placeholder={estadoCupon}
                            />
                        )}
                    />
                    <TextFieldFrom
                        select
                        label="No. Fracciones Mínimas*"
                        placeholder="No. Fracciones Mínimas*"
                        variant="outlined"
                        value={selectedNoFraccionesMinimas ? selectedNoFraccionesMinimas : noFraccionesMinimas}  // Usa el estado local para el valor
                        helperText={errorNoFraccionesMinimas.message}
                        onChange={handleNumeroFraccionesMinimas}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: 300 }} // Centra el TextField horizontalmente
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>

                    <TextFieldFrom
                        select
                        label="No. Fracciones Máximas*"
                        placeholder="No. Fracciones Máximas*"
                        variant="outlined"
                        value={selectedNoFraccionesMaximas ? selectedNoFraccionesMaximas : noFraccionesMaximas}  // Usa el estado local para el valor
                        helperText={errorNoFraccionesMaximas.message}
                        onChange={handleNumeroFraccionesMaximas}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: 300 }} // Centra el TextField horizontalmente
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>
                    <Dialog
                        open={showConfirmation}
                        onClose={handleConfirmationNo}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Editar Cupón"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ¿Está seguro de cambiar el estado  {estadoCupon}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmationNo}>No</Button>
                            <Button onClick={handleConfirmationYes} autoFocus>Sí</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={showConfirmationActulizacion}
                        onClose={handleConfirmationActulizacionNo}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Editar Cupón?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                No es posible activar el Cupón, valide la información vigente
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmationActulizacionNo}>OK</Button>
                        </DialogActions>
                    </Dialog>
                    {showMessage && (
                        <Alert severity="success">{mensageServicio}</Alert>
                    )}
                    <Button
                        type="submit"
                        variant="outlined"
                        sx={{ mt: 2 }}>
                        Editar
                    </Button>
                </Box>
            </div>
        </Edit>
    );
};
export const PopupExample = () => {
    return (<Popup trigger={<button>Trigger</button>} position="right center">
        <div>Popup content here !!</div>
    </Popup>);
};

export const CrearCupones = (props) => {
    // Estados del formulario
    const [nombreCupon, setNombreCupon] = useState('');
    const [porcentajeCupon, setPorcentajeCupon] = useState('');
    const [fechaHoraInicio, setFechaHoraInicio] = useState(dayjs());
    const [fechaHoraFinal, setFechaHoraFinal] = useState(dayjs());
    const [numeroCuponesRedimir, setNumeroCuponesRedimir] = useState('');
    const [producto, setProducto] = useState([]);
    const [productoLoteria, setProductoLoteria] = useState([]);
    const [estadoTodasLoterias, setEstadoTodasLoterias] = useState(false);
    const [loading, setLoading] = useState(true);
    const [noFraccionesMinimas, setNoFraccionesMinimas] = useState(0);
    const [noFraccionesMaximas, setNoFraccionesMaximas] = useState(0);

    const handleChangeNoFraccionesMinimas = (event) => {
        setNoFraccionesMinimas(event.target.value);
    };

    const handleChangeNoFraccionesMaximas = (event) => {
        setNoFraccionesMaximas(event.target.value);
    };


    //estados para el op up
    const [showMessage, setShowMessage] = useState(false);
    const [showMessageError, setShowMessageError] = useState(false);
    const [showMessageErrorDate, setShowMessageErrorDate] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [mensageServicio, setMensageServicio] = useState("");
    const [mensageServicioError, setMensageServicioError] = useState("");
    const [mensageServicioErrorDate, setMensageServicioErrorDate] = useState("");
    const [showMessageErrorFracciones, setShowMessageErrorFracciones] = useState(false);

    const [loterias, setLoterias] = useState([]);
    const [todasLoterias, setTodasLoterias] = useState([]);
    const fechaActual = new Date();

    // Estados de validación
    const [errorNombreCupon, setErrorNombreCupon] = useState({ error: false, message: '' });
    const [errorPorcentajeCupon, setErrorPorcentajeCupon] = useState({ error: false, message: '' });
    const [errorFechaHoraInicio, setErrorFechaHoraInicio] = useState({ error: false, message: '' });
    const [errorFechaHoraFinal, setErrorFechaHoraFinal] = useState({ error: false, message: '' });
    const [errorNumeroCuponesRedimir, setErrorNumeroCuponesRedimir] = useState({ error: false, message: '' });
    const [errorProducto, setErrorProducto] = useState({ error: false, message: '' });

const ajustarFecha = (fecha, horas) => {
        let nuevaFecha = new Date(fecha);
        nuevaFecha.setHours(nuevaFecha.getHours() - horas);
        return nuevaFecha;
    };

    const fechaHoraInicioAjustada = ajustarFecha(fechaHoraInicio.toDate(), 5);
    const fechaHoraFinalAjustada = ajustarFecha(fechaHoraFinal.toDate(), 5);

    const todos = [{
        abreviatura: 'TODOS',
        desLoteria: 'TODOS',
        ideClaseLoteria: 0,
        ideLoteria: 0,
        ideProducto: 0,
    }];

    const handleConfirmationNo = () => {
        setShowConfirmation(false);
    };

    const borrarDataFormulacio = () => {
        setNombreCupon("");
        setPorcentajeCupon("");
        setFechaHoraInicioValue(null);
        setfechaHoraFinalValue(null);
        setNumeroCuponesRedimir("");
        setProducto([]);
        setNoFraccionesMaximas("");
        setNoFraccionesMinimas("");
        setTimeout(() => {
            setFechaHoraInicioValue("");
            setfechaHoraFinalValue("");
        }, 500);
        setTimeout(() => {
            setShowMessage(false)
        }, 5000);
    };
    //validacion de espacios en el nombre
    const handleChange = (event) => {
        const alphanumericRegex = /^[a-zA-Z0-9]*$/;
        if (alphanumericRegex.test(event.target.value)) {
            setNombreCupon(event.target.value);
        } 
    }
    //validacion del procentaje no deje ingresar negativos
    const handleChangeNegativePorcentaje = (event) => {
        const alphanumericRegex = /^[0-9,.]*$/;
        if (alphanumericRegex.test(event.target.value)) {
            setPorcentajeCupon(event.target.value);
        }
    }
    const handleChangeNegativeCantidad = (event) => {
        const alphanumericRegex = /^[0-9,.]*$/;
        if (alphanumericRegex.test(event.target.value)) {
            setNumeroCuponesRedimir(event.target.value);
        }
    }

    const handleConfirmationYes = () => {
        setShowConfirmation(false);
        if (noFraccionesMinimas > noFraccionesMaximas) {
            setMensageServicioError('Error: Las fracciones mínimas no pueden ser mayores que las fracciones máximas.');
            setShowMessageError(true);
            setShowMessage(false);
            setShowMessageErrorFracciones(true); 
            return; 
        }
        if (fechaHoraFinalAjustada < fechaHoraInicioAjustada) {
            setMensageServicioError('Fecha Final es mayor a la fecha Inicial');
            setShowMessageError(true)
            setShowMessage(false)
            setShowMessageErrorFracciones(true)
        } else {
            console.log("validacion");
            let formatoValidoFechaInicial = new Date(fechaHoraInicio);
            let fechaInicioModificada = formatoValidoFechaInicial;
            console.log("data de fecha inicio", fechaInicioModificada);
            console.log("data de fecha actual", fechaActual);
            if (fechaActual.getTime() >= fechaInicioModificada.getTime()) {
                setMensageServicioErrorDate('La fecha de inicio no puede ser menor a la fecha actual');
                setShowMessageErrorDate(true)
            } else {
                setShowMessageErrorDate(false)
                let todasLoterias = [...loterias];
                let values = [{}];
                values = {
                    "nombre_cupon": nombreCupon,
                    "porcentaje_descuento": porcentajeCupon,
                    "fecha_hora_inicio": dayjs(fechaHoraInicioAjustada).utc().format(),
                    "fecha_hora_final": dayjs(fechaHoraFinalAjustada).utc().format(),
                    "numero_cupones_redimir": numeroCuponesRedimir,
                    "producto": producto,
                    "todos_productos": todasLoterias,
                    "createdAt": dayjs(fechaHoraInicioAjustada).utc().format(),
                    "updatedAt": dayjs(fechaHoraInicioAjustada).utc().format(),
                    "numeroFraccionesMinimas": noFraccionesMinimas,
                    "numeroFraccionesMaximas": noFraccionesMaximas
                };
                const gurdarCupon = async () => {
                    try {
                        const authToken = getAuthApp();
                        const headers = new Headers();
                        headers.append('Content-Type', 'application/json');
                        headers.append('Authorization', `${authToken}`);
                        const url = `${Constants.general.serverURL}/api/cupones/post-create-coupon`;
                        const body = {
                            coupon: values,
                            activity: 'createCoupon'
                        };
                        console.warn('BODY', JSON.stringify(body));
                        const response = await fetch(url, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify({ confisys: body }, null, 2)
                        });
                        if (response.ok) {
                            const responseData = await response.json();
                            const responseMessage = responseData.req;
                            setMensageServicio(responseMessage.message);
                            setShowMessage(true);
                            setShowMessageError(false);
                            borrarDataFormulacio();
                        } else {
                            setMensageServicio('Error al crear el cupón');
                            setShowMessage(true)
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                gurdarCupon();
            }
        }

    };

    

    const [errorNoFraccionesMinimas, setErrorNoFraccionesMinimas] = useState({
        error: false,
        message: ""
    });

    const [errorNoFraccionesMaximas, setErrorNoFraccionesMaximas] = useState({
        error: false,
        message: ""
    });

    const handleProductoChange = (event, value) => {
        setProducto(value);
    };
    const handleOnchenge = (e) => {
        e.preventDefault();
        let caracteres = new RegExp("^[a-zA-Z0-9 ]+$");
        if (nombreCupon) {
            if (!caracteres.test(nombreCupon)) {
                setErrorNombreCupon({
                    error: true,
                    message: "Este es un campo alfanumérico"
                });
            } else {
                setErrorNombreCupon({
                    error: false,
                    message: ""
                });
            }
        } else {
            setErrorNombreCupon({
                error: true,
                message: "Nombre Cupón es Requerido"
            });
        }
        if (porcentajeCupon) {

            if (porcentajeCupon.length > 3) {
                setErrorPorcentajeCupon({
                    error: true,
                    message: "Porcentaje Cupón No puedes digitar más de 3 caracteres "
                });
            } else {
                setErrorPorcentajeCupon({
                    error: false,
                    message: ""
                });
            }
        } else {
            setErrorPorcentajeCupon({
                error: true,
                message: "Porcentaje  Cupón es Requerido"
            });
        }
        if (fechaHoraInicio) {
            setErrorFechaHoraInicio({
                error: false,
                message: ""
            });
        } else {
            setErrorFechaHoraInicio({
                error: true,
                message: "Fecha Inicio es Requerida"
            });
        }
        if (fechaHoraFinal) {
            setErrorFechaHoraFinal({
                error: false,
                message: ""
            });
        } else {
            setErrorFechaHoraFinal({
                error: true,
                message: "Fecha Final es Requerida"
            });
        }
        if (numeroCuponesRedimir) {
            setErrorNumeroCuponesRedimir({
                error: false,
                message: ""
            });
        } else {
            setErrorNumeroCuponesRedimir({
                error: true,
                message: "Número de cupones es Requerido"
            });
        }
        if (producto.length > 0) {
            setErrorProducto({
                error: false,
                message: ""
            });
        } else if (producto.length == 0) {
            setErrorProducto({
                error: true,
                message: "Los Productos son Requeridos"
            });
        }
        if (noFraccionesMinimas >= 0 && noFraccionesMinimas <= 10) {
            setErrorNoFraccionesMinimas({
                error: false,
                message: ""
            });
        } else {
            setErrorNoFraccionesMinimas({
                error: true,
                message: "NO.Fracciones Mínimas debe estar entre 0 y 10"
            });
        }
        if (noFraccionesMaximas >= 0 && noFraccionesMaximas <= 10) {
            setErrorNoFraccionesMaximas({
                error: false,
                message: ""
            });
        } else {
            setErrorNoFraccionesMaximas({
                error: true,
                message: "NO.Fracciones Máximas debe estar entre 0 y 10"
            });
        }
        if (nombreCupon && porcentajeCupon && fechaHoraInicio &&
            fechaHoraFinal && numeroCuponesRedimir && producto.length > 0 && porcentajeCupon.length <= 3 &&
            noFraccionesMaximas >= 0 &&
            noFraccionesMaximas <= 10) {
            setShowConfirmation(true);
        }

    }
    useEffect(() => {
        const fetchLoterias = async () => {
            try {
                const authToken = getAuthApp();
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                headers.append('Authorization', `${authToken}`);
                const url = Constants.general.serverURL + "/api/Users/etn/consultar-loterias-disponibles";
                const values = {
                    evento: null,
                    fecha: "11-04-2018"
                };

                const response = await fetch(url, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ lottery: { ...values } }, null, 2)
                });
                if (response.ok) {
                    const responseData = await response.json();
                    const loteriasData = responseData.data;
                    const todasLoterias = [...loteriasData];
                    const loteriasWithAllOption = [todos[0], ...loteriasData];
                    setLoterias(loteriasWithAllOption);
                    setTodasLoterias(todasLoterias);
                    setLoading(false);
                } else {
                    throw new Error('Error al obtener los productos');
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchLoterias();
    }, []);
    return (
        <Create {...props} title="Crear Cupón" >

            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px', paddingTop: '20px' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gap: 1,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                    }}
                    component="form"
                    onSubmit={handleOnchenge}
                >
                    <TextFieldFrom
                        label="Nombre Cupón*"
                        type="text"
                        name="nombreCupon"
                        variant="outlined"
                        value={nombreCupon}
                        error={errorNombreCupon.error}
                        helperText={errorNombreCupon.message}
                        onChange={handleChange}
                        inputProps={{ maxLength: 30 }}
                        pattern="[A-Za-z0-9]+"
                    />
                    <TextFieldFrom
                        label="Porcentaje Descuento*"
                        type="text"
                        name="porcentajeCupon"
                        variant="outlined"
                        value={porcentajeCupon}
                        error={errorPorcentajeCupon.error}
                        helperText={errorPorcentajeCupon.message}
                        onChange={handleChangeNegativePorcentaje}
                        inputProps={{ maxLength: 4 }}
                    />

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            label="Fecha y hora de inicio*"
                            value={fechaHoraInicio}
                            onChange={setFechaHoraInicio}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={errorFechaHoraInicio.error}
                                    helperText={errorFechaHoraInicio.message}
                                />
                            )}
                        />
                        <DateTimePicker
                            label="Fecha y hora final*"
                            value={fechaHoraFinal}
                            onChange={setFechaHoraFinal}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={errorFechaHoraFinal.error}
                                    helperText={errorFechaHoraFinal.message}
                                />
                            )}
                        />
                    </LocalizationProvider>

                    <TextFieldFrom
                        name="numeroCuponesRedimir"
                        type="text"
                        label="No. Cupones Redimir*"
                        value={numeroCuponesRedimir}
                        error={errorNumeroCuponesRedimir.error}
                        helperText={errorNumeroCuponesRedimir.message}
                        onChange={handleChangeNegativeCantidad}
                        inputProps={{ maxLength: 11 }}
                    />
                    {!loading ? (
                        Array.isArray(loterias) && loterias.length > 0 ? (
                            <Autocomplete
                                multiple
                                selected="producto"
                                value={producto}
                                options={loterias}
                                getOptionLabel={(option) => option.desLoteria}
                                filterSelectedOptions
                                onChange={handleProductoChange}
                                renderInput={(params) => (
                                    <TextFieldFrom
                                        {...params}
                                        placeholder="Selecciona los Productos"
                                        error={errorProducto.error}
                                        helperText={errorProducto.message}
                                    />

                                )}
                            />
                        ) : (

                            <p>No se encontraron loterías disponibles.</p>
                        )
                    ) : (
                        <p>Cargando loterías...</p>
                    )}
                    <TextFieldFrom
                        select
                        label="No. Fracciones Mínimas*"
                        placeholder="No. Fracciones Mínimas*"
                        variant="outlined"
                        value={noFraccionesMinimas}
                        helperText={errorNoFraccionesMinimas.message}
                        onChange={handleChangeNoFraccionesMinimas}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>

                    <TextFieldFrom
                        select
                        label="No. Fracciones Máximas*"
                        placeholder="No. Fracciones Máximas*"
                        variant="outlined"
                        value={noFraccionesMaximas}
                        helperText={errorNoFraccionesMaximas.message}
                        onChange={handleChangeNoFraccionesMaximas}
                        fullWidth
                    >
                        {[...Array(11).keys()].map(num => (
                            <MenuItem key={num} value={num}>
                                {num}
                            </MenuItem>
                        ))}
                    </TextFieldFrom>
                    <Dialog
                        open={showConfirmation}
                        onClose={handleConfirmationNo}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Crear Cupón"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                ¿Está seguro que desea cargar el bono de descuento?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmationNo}>No</Button>
                            <Button onClick={handleConfirmationYes} autoFocus>Sí</Button>
                        </DialogActions>
                    </Dialog>
                    {showMessage && (
                        <Alert severity="success">{mensageServicio}</Alert>
                    )}
                    {showMessageError && (
                        <Alert severity="error">{mensageServicioError}</Alert>
                    )}
                    {showMessageErrorDate && (
                        <Alert severity="error">{mensageServicioErrorDate}</Alert>
                    )}
                    <Button type="submit"
                        variant="outlined"
                        sx={{ mt: 2 }}>
                        Guardar
                    </Button>
                </Box>
            </div>
        </Create>
    );
};

export const VistaCuponesCrear = (props) => {
    const [idLoteria, setIdLoteria] = useState([]);
    const [nombreLoteria, setNombreLoteria] = useState([]);
    const [loteriacupones, setLoteriaCupones] = useState([]);


    //variable que retorna el id editar
    let id = props.match.params['id'];
    let values = [{}];
    values = {
        "idCupon": id
    };
    //consultar los id relacionados con el cupon
    const consultarIdLoteriaCupon = async () => {
        try {
            const authToken = getAuthApp();
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', `${authToken}`);
            const url = `${Constants.general.serverURL}/api/cupones/post-consult-id-loteria-cupon`;
            const body = {
                coupon: values
            };
            console.warn('BODY', JSON.stringify(body));
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ confisys: body }, null, 2)
            });
            if (response.ok) {
                const responseData = await response.json();
                const responseMessage = responseData.req;
                setLoteriaCupones(responseMessage.body);
            } else {
                throw new Error('Error al consultar estado cupón');
            }
        } catch (error) {
            console.error(error);
        }
    }
    consultarIdLoteriaCupon();
    return (
        <Show {...props} title="Loterías Relacionadas con el Cupón" >
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '20px' }}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>IdLotería</TableCell>
                                <TableCell align="right">Nombre Lotería </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loteriacupones.map((row) => (
                                <TableRow
                                    key={row.idLoteria}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.idLoteria}
                                    </TableCell>
                                    <TableCell align="right">{row.nombreLoteria}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Show>)
};


const estados = [
    "ACTIVO",
    "INACTIVO"
];
